import Chart from 'chart.js'
import Controller from './controllers/controller.funnel.js'

Chart.controllers.funnel = Controller
